export const srErrors = {
	"http-login-error": "Greška u komunikaciji sa serverom",
	"E-4": "Niste ovlašćeni za rad u aplikaciji",
};
